export default "__VITE_ASSET__B75ynS7k__"